import { motion } from 'framer-motion'
import type { ReactNode } from 'react'
import { useIsSSR } from '@/context/SSRContext'

interface PageTransitionProps {
  children: ReactNode
}

export default function PageTransition({ children }: PageTransitionProps) {
  const isSSR = useIsSSR()

  return (
    <motion.div
      initial={isSSR ? false : { opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -8 }}
      transition={{ duration: 0.35, ease: [0.16, 1, 0.3, 1] }}
    >
      {children}
    </motion.div>
  )
}
